import React, { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
  Spinner,
} from "reactstrap";

import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import Breadcrumb from "../../../../components/Common/Breadcrumb";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../../helpers/show_notification";
import {
  ExportAvailableInCSVForReports,
  formatUnitsForReport,
} from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";

const BranchwiseItemUsedInventoriesReport = (props) => {
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
  }, []);

  useEffect(() => {
    if (dateFrom > dateTo) {
      setFilteredOrders([]);
      setAllOrders([]);
    }
  }, [dateFrom, dateTo]);

  const [allOrders, setAllOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      const daysDiff = moment(dateTo).diff(dateFrom, "days");
      if (daysDiff > 31) {
        setFilteredOrders([]);
        showNotification("Total number of days cannot be more than 31.", "Error");
        return false;
      } else if (daysDiff < 0) {
        setFilteredOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      setIsLoadingOrders(true);
      setFilteredOrders([]);
      const url =
        process.env.REACT_APP_BASEURL + "reports/branchwise_used_items_new";
      const response = await postSubmitForm(url, {
        date_from: dateFrom ? dateFrom : moment().format("YYYY-MM-DD"),
        date_to: dateTo ? dateTo : moment().format("YYYY-MM-DD"),
      });
      if (requestId !== ordersRequestId.current) return false;
      if (response && response.status === 1) {
        const allData = (response.data || []).map((row, index) => ({
          ...row,
          row_key: row.id || `${row._id}_${index}`,
          item_name:
            row.item_details && row.item_details.name
              ? row.item_details.name
              : "",
          item_category:
            row.item_details && row.item_details.category
              ? row.item_details.category
              : "",
          item_sub_category:
            row.item_details && row.item_details.sub_category
              ? row.item_details.sub_category
              : "",
        }));
        if (allData.length <= 0) {
          showNotification("No Orders data found", "error");
        }
        setAllOrders(allData);
        setFilteredOrders(allData);
      } else {
        showNotification((response && response.message) || "Error", "Error");
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return false;
      console.log(error);
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  function afterFilter(newResult) {
    setFilteredOrders((prevOrders) => {
      const next = newResult || [];
      if (
        prevOrders.length === next.length &&
        prevOrders.every((row, index) => row === next[index])
      ) {
        return prevOrders;
      }
      return next;
    });
  }

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const pagination_options = {
    sizePerPage: pageSize,
    onSizePerPageChange: (sizePerPage) => {
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const columns = [
    {
      dataField: "row_key",
      hidden: true,
    },
    {
      dataField: "serial",
      isDummyField: true,
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      footer: true,
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Branch"),
      dataField: "branch_name",
      sort: true,
      footer: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      formatter: (cell, row) => {
        return (
          <span className="text-info mr-2">
            {row.branch_name}{" "}
            <span
              hidden={!row.is_free}
              className="text-danger"
              style={{ fontSize: "20px" }}
            >
              *
            </span>
          </span>
        );
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.branch_name)
                .map((row) => [
                  row.branch_name,
                  { value: row.branch_name, label: row.branch_name },
                ])
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
    },
    {
      text: props.t("Item"),
      dataField: "item_name",
      sort: true,
      footer: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.item_name)
                .map((row) => [
                  row.item_name,
                  { value: row.item_name, label: row.item_name },
                ])
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
    },
    {
      text: props.t("Category"),
      dataField: "item_category",
      sort: true,
      footer: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.item_category)
                .map((row) => [
                  row.item_category,
                  { value: row.item_category, label: row.item_category },
                ])
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      footer: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "is_free",
      text: props.t("Free ?"),
      sort: false,
      footer: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
      }),
    },
    {
      text: props.t("Quantity"),
      dataField: "quantity",
      footer: true,
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Cost"),
      dataField: "total_cost",
      formatter: (cell, row) => {
        if (row?.is_free) {
          return (
            <div>
              <div>Projected: {row?.projected_cost}</div>
            </div>
          );
        } else {
          return row?.total_cost;
        }
      },
      footer: (columnData) =>
        columnData.reduce((acc, item) => Number((acc + item).toFixed(2)), 0),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Used Date"),
      dataField: "createdAt",
      formatter: (cell, row) => {
        return row.createdAt
          ? moment(row.createdAt).format("DD/MM/YYYY HH:mm")
          : "";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  const handleDownload = async () => {
    const fileName = "branchwise_item_used_report";
    const exportType = "xls";

    let data_to_export =
      filteredOrders && filteredOrders.length ? filteredOrders : allOrders;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          BranchName: v.branch_name,
          Items: v.item_name,
          Category: v.item_category,
          SubCategory: v.item_sub_category,
          Batch: v.batch,
          Free: v.is_free ? "Yes" : "No",
          Quantity: ExportAvailableInCSVForReports(v.quantity),
          Cost: v.is_free ? v.projected_cost : v.total_cost,
          "Used Date": v.createdAt
            ? moment(v.createdAt).format("DD/MM/YYYY HH:mm")
            : "",
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Branchwise Used Item Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Branchwise Used Item Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            setDateFrom(formatDate(e.target.value));
                          }}
                          errorMessage={props.t("Date cannot be empty.")}
                          max={moment().format("YYYY-MM-DD")}
                          validate={{
                            required: { value: true },
                            date: { value: true },
                            max: {
                              value: moment().format("YYYY-MM-DD"),
                              errorMessage: props.t(
                                "Future dates are not allowed"
                              ),
                            },
                          }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            setDateTo(formatDate(e.target.value));
                          }}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{
                            required: { value: true },
                            date: { value: true },
                            max: {
                              value: moment().format("YYYY-MM-DD"),
                              errorMessage: props.t(
                                "Future dates are not allowed"
                              ),
                            },
                            min: {
                              value: moment(dateFrom).format("YYYY-MM-DD"),
                              errorMessage: props.t(
                                "To Date cannot be earlier than From Date"
                              ),
                            },
                          }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="button"
                          className="btn btn-md btn-success mt-4"
                          disabled={isLoadingOrders}
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          {isLoadingOrders ? (
                            <Spinner size="sm" className="mr-1" />
                          ) : (
                            <i className="mdi mdi-checkbox-marked-circle"></i>
                          )}{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Branchwise Used Item Report")}{" "}
                    </CardTitle>

                    <ToolkitProvider
                      keyField="row_key"
                      data={allOrders && allOrders}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          {isLoadingOrders ? (
                            <div className="text-center py-5">
                              <Spinner color="primary" />
                            </div>
                          ) : (
                            <BootstrapTable
                              striped
                              hover
                              condensed
                              filter={filterFactory({ afterFilter })}
                              pagination={paginationFactory(pagination_options)}
                              {...toolkitProps.baseProps}
                            />
                          )}
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(
    mapStatetoProps,
    {}
  )(withNamespaces()(BranchwiseItemUsedInventoriesReport))
);
